export enum JobRiskClass {
  '4A' = '4A',
  '3A' = '3A',
  '2A' = '2A',
  '1A' = '1A',
  'B' = 'B',
  'C' = 'C',
  'INELIGIBLE' = 'INELIGIBLE',
}
